import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import CalendarListItem from './CalendarListItem';

import CalendarActions from '../../actions/CalendarActionCreator';
import CalendarStore from '../../stores/CalendarStore';

class CalendarList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            calendars: [],
            count: 0,
            page: 0,
            limit: 50,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);

        CalendarStore.addChangeListener(this.onChange);
        CalendarActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        CalendarStore.removeChangeListener(this.onChange);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/calendar/new' : '';

        return (
            <ListView
                title="Calendars"
                items={this.state.calendars}
                itemDecorator={CalendarListItem}
                newEntityUrl={newEntityUrl}
            />
        )
    }

    onChange() {
        this.setState({calendars: CalendarStore.getAll({limit: this.state.limit})});
    }
}

CalendarList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CalendarList;
